import React, { useContext } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';

import DyteClient from '@dytesdk/web-core';
import { IconPack, defaultIconPack } from '../lib/icons';
import { States } from '../types/props';
import { DyteI18n, useLanguage } from '../lib/lang';
import DyteText from './DyteText';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  iconPack = defaultIconPack,
  states,
  t,
  onClose,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  states?: States;
  t?: DyteI18n;
  onClose: any;
}) {
  const canKickParticipant = meeting.self.permissions.kickParticipant;
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  states = states ?? storeStates;
  const styles = StyleSheet.create({
    buttonStyle: {
      borderRadius: 4,
      height: 40,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 16,
    },
    endMeeting: {
      height: 40,
      width: '100%',
      borderRadius: 5,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#ff5050',
    },
    endMeetingContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 15,
      justifyContent: 'space-around',
    },
    mainContainer: {
      paddingHorizontal: 16,
      borderRadius: 4,
    },
    cancelButton: {
      flexDirection: 'row',
      paddingTop: 15,
      justifyContent: 'space-around',
    },
  });
  return (
    <View style={styles.mainContainer}>
      {/* eslint-disable-next-line react-native/no-inline-styles */}
      <View style={{ paddingVertical: 25 }}>
        <DyteText size={'xl'} fontWeight="bold">
          {t('leave')}
        </DyteText>
      </View>
      <View>
        <DyteText size="md">{t('leave_confirmation')}</DyteText>
      </View>

      {/* eslint-disable-next-line react-native/no-inline-styles */}
      <View style={{ paddingVertical: 20 }}>
        <View style={styles.cancelButton}>
          <TouchableHighlight
            underlayColor={colors.background[800]}
            onPress={onClose}
            // eslint-disable-next-line react-native/no-inline-styles
            style={{ flex: 1, marginHorizontal: 4 }}
          >
            <View
              style={{
                ...styles.buttonStyle,
                backgroundColor: colors.background[600],
              }}
            >
              <DyteText size="md">{t('cancel')}</DyteText>
            </View>
          </TouchableHighlight>
          <TouchableHighlight
            underlayColor={colors.background[800]}
            onPress={async () => {
              setStates({
                ...states,
                activeLeaveConfirmation: false,
              });
              await meeting.leaveRoom().catch((err) => console.log(err));
            }}
            // eslint-disable-next-line react-native/no-inline-styles
            style={{ flex: 1 }}
          >
            <View
              style={{
                ...styles.buttonStyle,
                backgroundColor: colors.danger,
              }}
            >
              <DyteText size="md">{t('leave')}</DyteText>
            </View>
          </TouchableHighlight>
        </View>
        <View>
          {canKickParticipant && (
            <TouchableHighlight
              underlayColor={colors.background[800]}
              onPress={async () => {
                setStates({
                  ...states,
                  activeLeaveConfirmation: false,
                });
                await meeting.participants
                  .kickAll()
                  .catch((err) => console.log(err));
                await meeting.leaveRoom().catch((err) => console.log(err));
              }}
            >
              <View style={styles.endMeetingContainer}>
                <View style={styles.endMeeting}>
                  <DyteText size="md">{t('end')}</DyteText>
                </View>
              </View>
            </TouchableHighlight>
          )}
        </View>
      </View>
    </View>
  );
}
